import React, {useState, useRef, useEffect } from 'react';
import { useAddressAutofillCore } from '@mapbox/search-js-react';
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from "react-router-dom";

// Added Translation scope

const PartnerForm = (props) => {
  const captchaRef = useRef(null);
  const [ip, setIP] = useState("");
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  const autofill = useAddressAutofillCore({
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
    language: [props.lang],
    options: {
      country: 'CA',     // restricts results to Canada
      language: [props.lang],
    }
  });
  useEffect(() => {
    axios.get("https://api.ipify.org/?format=json").then(res => setIP(res.data.ip));
  }, []);
  const errorMessage = props.lang === 'fr' ? 'S\'il vous plaît, mettez une adresse email valide.' : 'Please enter a valid email address.';
  const errorEmailFoundMessage = props.lang === 'fr' ? 'Cette adresse e-mail est déjà enregistrée. <a href="https://mytl.travelance.ca/TL/#/" target="_blank">Veuillez cliquer ici pour vous connecter.</a>' : 'This email is already registered. <a href="https://mytl.travelance.ca/#/" target="_blank">Please click here to log in.</a>';
  const recaptchaNotChecked = props.lang === 'fr' ? "Veuillez cliquer sur la case reCAPTCHA." : "Please click on the reCAPTCHA box.";
  const labelEM = props.lang === 'fr' ? "Adresse courriel" : "Email Address";
  const labelMA = props.lang === 'fr' ? "MGA/Agence" : "MGA/Agency";
  const labelFN = props.lang === 'fr' ? "Prénom" : "First Name";
  const labelLN = props.lang === 'fr' ? "Nom" : "Last Name";
  const labelMN = props.lang === 'fr' ? "Deuxième prénom" : "Middle Name";
  const labelBP = props.lang === 'fr' ? "Téléphone d’affaires" : "Business Phone";
  const labelPSA = props.lang === 'fr' ? "Adresse de rue principale" : "Primary Street Address";
  const labelPAC = props.lang === 'fr' ? "Adresse principale Ville" : "Primary Address City";
  const labelPAP = props.lang === 'fr' ? "Adresse principale Province" : "Primary Address Province";
  const labelPC = props.lang === 'fr' ? "Code postal" : "Postal Code";
  const consent = props.lang === 'fr' ? "En cochant cette case, vous acceptez de recevoir des courriels marketing à l’avenir." : "By checking this box, you agree to receive future marketing emails";
  const labelSb = props.lang === 'fr' ? "Envoyer" : "Submit";
  const labelSP = props.lang === 'fr' ? "Sélectionnez une province" : "Select Province";
  const labelSAT = props.lang === 'fr' ? "Sélectionner le type d'agent" : "Select Agent Type";
  const mgaTooltip = props.lang === 'fr' ? "AGG ou agence de voyage / générale avec laquelle vous êtes associé(e). Ajoutez Travelance si vous n’êtes associé(e) à aucune agence." : "MGA or General / Travel Agency you are associated with. Add Travelance if no Agency";

  const provinces = [
    { "en": "Alberta", "fr": "Alberta", "abr":"AB"  },
    { "en": "British Columbia", "fr": "Colombie-Britannique", "abr":"BC"  },
    { "en": "Manitoba", "fr": "Manitoba", "abr":"MB"  },
    { "en": "New Brunswick", "fr": "Nouveau-Brunswick", "abr":"NB"  },
    { "en": "Newfoundland and Labrador", "fr": "Terre-Neuve-et-Labrador", "abr":"NL"  },
    { "en": "Nova Scotia", "fr": "Nouvelle-Écosse", "abr":"NS"  },
    { "en": "Ontario", "fr": "Ontario", "abr":"ON"  },
    { "en": "Prince Edward Island", "fr": "Île-du-Prince-Édouard", "abr":"PE"  },
    { "en": "Quebec", "fr": "Québec", "abr":"QC"  },
    { "en": "Saskatchewan", "fr": "Saskatchewan", "abr":"SK"  },
    { "en": "Northwest Territories", "fr": "Territoires du Nord-Ouest", "abr":"NT"  },
    { "en": "Nunavut", "fr": "Nunavut", "abr":"NU"  },
    { "en": "Yukon", "fr": "Yukon", "abr":"YT" }
  ];
  const brokerTypes = [
    {"value": "Broker","en": "Broker","fr": "Courtier"},
    {"value": "Company Rep","en": "Company Rep","fr": "Représentant de l'entreprise"},
    {"value": "General Agency Rep","en": "General Agency Rep","fr": "Représentant d'agence générale"},
    {"value": "General Agent","en": "General Agent","fr": "Agent général"},
    {"value": "MGA Rep","en": "MGA Rep","fr": "Représentant de MGA"},
    {"value": "Travel Agent","en": "Travel Agent","fr": "Agent de voyage"},
    {"value": "Travel Agency Rep","en": "Travel Agency Rep","fr": "Représentant d'agence de voyage"},
    {"value": "Unknown","en": "Unknown","fr": "Inconnu"}
  ];

  const onlyAlphabets = (e) => {
    const code = e.which || e.keyCode;
    const allowed = (code >= 48 && code <= 57 )||(code >= 64 && code <= 90) || (code >= 95 && code <= 122) || [8, 9, 13, 16, 32, 37, 38, 39, 40].includes(code);
    if (!allowed) e.preventDefault();
  };
  const onlyPhoneNo = (e) => {
    const code = e.which || e.keyCode;
    if (!((code >= 48 && code <= 57) || code === 43)) e.preventDefault();
  };
  const validateEmailAdd = async (e) => {
    const input = e.target;
    const valid = /^\w+(['.\-+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(input.value);
    const emailIn = document.getElementById('email');
    const email = document.getElementById('email').value;
    const errorBox = document.querySelector('.emailError1');
    const submitBtn = document.querySelector('input[type="submit"]');
    console.log(errorBox);

    if (!valid) {
      errorBox.textContent = errorMessage;
      errorBox.classList.remove('hidden');
      errorBox.classList.add('show');
      emailIn.classList.add('error');
      submitBtn.disabled = true;
      input.setCustomValidity(errorMessage);
      return;
    }
    try {
      const url = `${process.env.REACT_APP_API}validateEmail`;
      const { data } = await trackPromise(axios.post(url, { email:email }));
      if (!data.status) {
        errorBox.innerHTML = errorEmailFoundMessage;
        errorBox.classList.remove('hidden');
        errorBox.classList.add('show');
        emailIn.classList.add('error');
        submitBtn.disabled = true;
        input.setCustomValidity('This email is already registered.');
        ////input.reportValidity();
      } else {
        errorBox.textContent = '';
        errorBox.classList.add('hidden');
        errorBox.classList.remove('show');
        emailIn.classList.remove('error');
        submitBtn.disabled = false;
        input.setCustomValidity('');
      }
    } catch (error) {
      console.error("Email validation failed", error);
      input.setCustomValidity('Unable to validate email. Try again.');
    }
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    console.log(value);
    setQuery(value);
    if (value.length > 2) {
      try {
        console.log(autofill);
        const result = await autofill.suggest(value, { sessionToken: 'test-123' });
        console.log(result);
        setSuggestions(result.suggestions);
      } catch (err) {
        console.error(err);
      }
    } else {
      setSuggestions([]);
    }
  };
  const handleSelectSuggestion = (address) => {
    setQuery(address.address_line1);
    document.getElementById("primary_address_city").value = address.place;
    document.getElementById("primary_address_state").value = address.region_code;
    document.getElementById("primary_address_postalcode").value = address.postcode;
    setSuggestions([]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = captchaRef.current.getValue();
    if (!token) return alert({recaptchaNotChecked});
    captchaRef.current.reset();
    const formData = new FormData(e.target);
    const dataToSubmit = Object.fromEntries(formData.entries());
    dataToSubmit.grecaptcharesponse = token;
    try {
      const url = `${process.env.REACT_APP_API}addLead`;
      const { data } = await trackPromise(axios.post(url, dataToSubmit));
      if (data.status) {
        navigate(props.typage);
        window.location.replace('https://www.travelance.ca/partner/form/thank-you/');
      } else {
        const errorBox = document.getElementById("error_message");
        if (data.cause?.includes("ResourceAlreadyInUseException")) {
          errorBox.innerHTML = errorEmailFoundMessage;
        } else {
          errorBox.textContent = data.message;
        }
        errorBox.classList.add('show');
      }
    } catch (err) {
      console.error("Submission error", err);
    }
  };

  return (
    <>
      <form  id="WebToLeadForm" name="WebToLeadForm" onSubmit={handleSubmit}>
        <input id="client_ip" type="hidden" name="client_ip" value={ip} />
        <input id="email_opt_in" type="hidden" name="email_opt_in" value="off" />
        <h2>{props.heading}</h2>
        <label>{labelEM}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="email" type="text" name="email1" onBlur={ validateEmailAdd } required />
        <div className="emailError1 hidden"></div>
        <br />
        <label>{labelMA}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        {
          props.mga ?
          <>
            {
              props.mga === 'wfg'?
              (<input style={{backgroundColor:'#f4f4f4'}} className="select" id="account_name" type="text" name="account_name" value="World Financial Group (MGA)" readOnly={true}/>):""
            }
            {
              props.mga === 'efg' ?
              (<input style={{backgroundColor:'#f4f4f4'}} className="select" id="account_name" type="text" name="account_name" value="Experior Financial Group (MGA)" readOnly={true} />):""
            }
            {
              props.mga === 'gfic' ?
              (<input style={{backgroundColor:'#f4f4f4'}} className="select" id="account_name" type="text" name="account_name" value="Greatway Financial Group (MGA)" readOnly={true} />):""
            }
            {
              props.mga === 'punjab' ?
              (<input style={{backgroundColor:'#f4f4f4'}} className="select" id="account_name" type="text" name="account_name" value="Punjab Insurance (MGA)" readOnly={true} />):""
            }
          </>
          :
            <>
              <input className="select" id="account_name" type="text" name="account_name" onKeyPress={ onlyAlphabets } required /><span style={{fontSize: '0.8em',color: '#7393b3'}}>{mgaTooltip}</span>
            </>
        }
        <br />
        {
          props.mga  ?
          <>
          <input id="agent_type" type="hidden" name="agent_type" value="Broker" />
          </>
          :
          <>
          <label>Type: <span className="required" style={{color: '#ff0000'}}>*</span></label>
          <br />
          <select className="select" id="agent_type" name="agent_type" type="text" required>
            <option >--{labelSAT}--</option>
            {brokerTypes.map((brok) => (
              <option key={`brok-${brok.value}`} value={brok.value}>{brok[props.lang]}</option>
            ))}
          </select>
          <br />
          </>
        }
        <label>{labelFN}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="first_name" type="text" name="first_name" onKeyPress={ onlyAlphabets } required />
        <br />
        <label>{labelMN}:</label>
        <br />
        <input className="select" id="middle_name_c" type="text" name="middle_name_c" onKeyPress={ onlyAlphabets } />
        <br />
        <label>{labelLN}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="last_name" type="text" name="last_name" onKeyPress={ onlyAlphabets } required />
        <br />
        {
          props.mga==='wfg'
          ?
          <>
            <label>WFG Code: <span className="required" style={{color: '#ff0000'}}>*</span></label>
            <br /><input className="select" id="wfg_code_c" type="text" name="wfg_code_c" required/><br />
          </>
          :""
        }
        <label>{labelBP}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="phone_mobile" type="text" name="phone_mobile" maxLength="11" onKeyPress={ onlyPhoneNo } required />
        <br />
        <label>{labelPSA}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <div className="address-autofill-container">
          <textarea className="select address-input" id="primary_address_street" type="text" name="primary_address_street" value={query} onChange={handleInputChange} required></textarea>
          {
            suggestions.length > 0 && (
              <div className="suggestion-box">
              {suggestions.map((address, index) => (
                <div className="suggestion-item" key={index} onClick={() => handleSelectSuggestion(address)} style={{padding: '8px',cursor: 'pointer',borderBottom: index === suggestions.length - 1 ? 'none' : '1px solid #ddd',}}>
                {address.place_name}
                </div>
              ))}
              </div>
            )
          }
        </div>
        <br />
        <label>{labelPAC}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="primary_address_city" type="text" name="primary_address_city" required />
        <br />
        <label>{labelPAP}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <select className="select" id="primary_address_state" type="text" name="primary_address_state" required>
          <option>-- {labelSP} --</option>
          {provinces.map((prov) => (
            <option key={`prov-${prov.abr}`} value={prov.abr}>{prov[props.lang]}</option>
          ))}
        </select>
        <br />
        <label>{labelPC}: <span className="required" style={{color: '#ff0000'}}>*</span></label>
        <br />
        <input className="select" id="primary_address_postalcode" type="text" name="primary_address_postalcode" required />
        <br />
        <input id="email_opt_in" type="checkbox" name="email_opt_in" /> {consent}
        <br />
        <br />
        <ReCAPTCHA sitekey="6Leqq-kUAAAAAH5ekaYckwmGLXuDcDp9U2X0ipip" ref={captchaRef} />
        <br />
        <br />
        <input className="btn btn-primary" type="submit" name={labelSb} value={labelSb} />
        <table>
          <tbody>
            <tr>
              <td style={{display: 'none'}}><input id="campaign_id" type="hidden" name="campaign_id" value="001979bc-ae88-11eb-b294-022500f56390" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="redirect_url" type="hidden" name="redirect_url" value="https://www.travelance.ca/partner/form/thank-you/" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="redirectRequestType" type="hidden" name="redirectRequestType" value="GET" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="redirectIncludeParams" type="hidden" name="redirectIncludeParams" value="1" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="assigned_user_id" type="hidden" name="assigned_user_id" value="1" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="team_id" type="hidden" name="team_id" value="1" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="team_set_id" type="hidden" name="team_set_id" value="1" /></td>
            </tr>
            <tr>
              <td style={{display: 'none'}}><input id="req_id" type="hidden" name="req_id" value="last_name;email;" /></td>
            </tr>
          </tbody>
        </table>
        <div id="error_message"></div>
      </form>
    </>
  );
}

export default PartnerForm;
